module.exports = __webpack_public_path__ + "img/bg_tt.9da94158.png";